// src/context/AuthContext.js
import React, { createContext, useContext, useEffect, useState } from 'react';
import { login as loginService, logout as logoutService, isAuthenticated } from '../services/AuthService';

const AuthContext = createContext();

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);

  // Vérifie si l'utilisateur est connecté lors du chargement de l'application
  useEffect(() => {
    const storedUser = localStorage.getItem('user');
    if (isAuthenticated() && storedUser) {
      setUser(JSON.parse(storedUser));
    }
  }, []);

  const login = async (email, password) => {
    const user = await loginService(email, password);
    setUser(user);
  };

  const updateUser = (updateUser) => {
    setUser(updateUser);
    localStorage.setItem("user", JSON.stringify(updateUser));
  }

  const logout = () => {
    logoutService();
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, updateUser, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
};

export const useAuth = () => useContext(AuthContext);
